"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1385],{

/***/ 1385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ fetchMyCommunityPost; },
/* harmony export */   "AN": function() { return /* binding */ fetchCharacterPost; },
/* harmony export */   "Ak": function() { return /* binding */ voteCommunityPoll; },
/* harmony export */   "IM": function() { return /* binding */ patchCharacterPost; },
/* harmony export */   "Ic": function() { return /* binding */ postMyCommunityPost; },
/* harmony export */   "Nt": function() { return /* binding */ postCharacterPost; },
/* harmony export */   "Q4": function() { return /* binding */ fetchCharacterPosts; },
/* harmony export */   "SD": function() { return /* binding */ fetchPost; },
/* harmony export */   "VH": function() { return /* binding */ deleteMyCommunityPost; },
/* harmony export */   "Yn": function() { return /* binding */ toggleCharacterPostLike; },
/* harmony export */   "_P": function() { return /* binding */ togglePostLike; },
/* harmony export */   "bg": function() { return /* binding */ fetchUserPosts; },
/* harmony export */   "gK": function() { return /* binding */ recommendCommunityPostTags; },
/* harmony export */   "kQ": function() { return /* binding */ fetchCommunityFeedSearch; },
/* harmony export */   "lR": function() { return /* binding */ patchMyCommunityPost; },
/* harmony export */   "q1": function() { return /* binding */ deleteCharacterPost; },
/* harmony export */   "ur": function() { return /* binding */ fetchCommunityFeed; }
/* harmony export */ });
/* unused harmony exports fetchMyPosts, fetchCommunityFeedSearchTrends, fetchCommunityFeedPublic */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79825);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var camelize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94100);
/* harmony import */ var camelize__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(camelize__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45874);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var fetchPost = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/communities/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPost(id) {
        return _ref.apply(this, arguments);
    };
}();
var togglePostLike = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/communities/".concat(id, "/like/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function togglePostLike(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUserPosts = function() {
    var _ref = _asyncToGenerator(function(userId) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/users/".concat(userId, "/communities/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchUserPosts(userId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyPosts = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/users/me/communities/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyPosts() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyCommunityPost = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/users/me/communities/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyCommunityPost(id) {
        return _ref.apply(this, arguments);
    };
}();
var postMyCommunityPost = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/users/me/communities/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMyCommunityPost(payload) {
        return _ref.apply(this, arguments);
    };
}();
var patchMyCommunityPost = function() {
    var _ref = _asyncToGenerator(function(_param) {
        var id, payload, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = _param.id, payload = _objectWithoutProperties(_param, [
                        "id"
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.patch */ .hi.patch("/users/me/communities/".concat(id, "/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchMyCommunityPost(_param) {
        return _ref.apply(this, arguments);
    };
}();
var deleteMyCommunityPost = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api["delete"] */ .hi["delete"]("/users/me/communities/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function deleteMyCommunityPost(id) {
        return _ref.apply(this, arguments);
    };
}();
/* 투표 API */ var voteCommunityPoll = function() {
    var _ref = _asyncToGenerator(function(communityId, optionId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/communities/".concat(communityId, "/poll/votes/"), {
                            optionId: optionId
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function voteCommunityPoll(communityId, optionId) {
        return _ref.apply(this, arguments);
    };
}();
/* 캐릭터 커뮤니티 api */ var fetchCharacterPost = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/play/communities/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCharacterPost(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCharacterPosts = function() {
    var _ref = _asyncToGenerator(function(characterId) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/play/characters/".concat(characterId, "/communities/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCharacterPosts(characterId) {
        return _ref.apply(this, arguments);
    };
}();
var postCharacterPost = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/play/my-communities/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postCharacterPost(payload) {
        return _ref.apply(this, arguments);
    };
}();
var patchCharacterPost = function() {
    var _ref = _asyncToGenerator(function(_param) {
        var postId, payload, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    postId = _param.postId, payload = _objectWithoutProperties(_param, [
                        "postId"
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.patch */ .hi.patch("/play/my-communities/".concat(postId, "/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchCharacterPost(_param) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCharacterPost = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api["delete"] */ .hi["delete"]("/play/my-communities/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function deleteCharacterPost(id) {
        return _ref.apply(this, arguments);
    };
}();
var toggleCharacterPostLike = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/play/communities/".concat(id, "/like/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function toggleCharacterPostLike(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCommunityFeed = function() {
    var _ref = _asyncToGenerator(function() {
        var type, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "recent", page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/communities/feed/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            type: type
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCommunityFeed() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCommunityFeedSearch = function() {
    var _ref = _asyncToGenerator(function(tagName) {
        var ordering, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ordering = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "popular", page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/community-posts/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            tagNames: tagName,
                            ordering: ordering,
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCommunityFeedSearch(tagName) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCommunityFeedSearchTrends = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/community-post-search-trends/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.items
                    ];
            }
        });
    });
    return function fetchCommunityFeedSearchTrends() {
        return _ref.apply(this, arguments);
    };
}();
var recommendCommunityPostTags = function() {
    var _ref = _asyncToGenerator(function(content) {
        var data, _tagNames;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/community-post-tag-recommendations/", {
                            content: content
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        (_tagNames = data.tagNames) !== null && _tagNames !== void 0 ? _tagNames : []
                    ];
            }
        });
    });
    return function recommendCommunityPostTags(content) {
        return _ref.apply(this, arguments);
    };
}();
var publicApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://api.chatie.me",
    responseType: "json",
    transformRequest: ___WEBPACK_IMPORTED_MODULE_2__/* .transformRequest */ .Sw,
    transformResponse: _toConsumableArray(___WEBPACK_IMPORTED_MODULE_2__/* .defaultTransformResponse */ .aH).concat([
        function(data) {
            return camelize__WEBPACK_IMPORTED_MODULE_1___default()(data.result);
        }, 
    ])
});
var fetchCommunityFeedPublic = function() {
    var _ref = _asyncToGenerator(function() {
        var // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _type, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _type = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "latest", page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        publicApi.get("/communities/feed/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_3__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            type: "recent"
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCommunityFeedPublic() {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);